import helpers from "./helpers";
export default {

    getAccessToken : () => {
        return helpers.getCookie('API_DRUG_access_token')
    },

    setCredentials : (accessToken, refreshToken, user) => {
        localStorage.setItem('access-token', accessToken);
        localStorage.setItem('refresh-token', refreshToken);
        localStorage.setItem('user', user);
        document.cookie = `accessToken=${accessToken}; expires=Wed, 18 Dec 2030 12:00:00 UTC; path=/` // Todo : Remove this
        document.cookie = `API_DRUG_access_token=${accessToken}; expires=Wed, 18 Dec 2030 12:00:00 UTC; path=/`
    },

    removeCredentials : () => {
        localStorage.clear();
        helpers.deleteCookie('accessToken');
        helpers.deleteCookie('API_DRUG_access_token');
    },

    getCredentials : () => {
        return {
            user : localStorage.getItem('user'),
            accessToken : localStorage.getItem('access-token'),
            refreshToken : localStorage.getItem('refresh-token')
        }
    }
}